import copy from 'copy-to-clipboard';
export function copyToClipboard(text) {
    copy(text, { format: 'text/plain' });
}
